import { render, staticRenderFns } from "./HotspotsPanel.vue?vue&type=template&id=38f66c98&scoped=true&"
import script from "./HotspotsPanel.vue?vue&type=script&lang=js&"
export * from "./HotspotsPanel.vue?vue&type=script&lang=js&"
import style0 from "./HotspotsPanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HotspotsPanel.vue?vue&type=style&index=1&id=38f66c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f66c98",
  null
  
)

export default component.exports